<template>
  <!--
      name:RelatedRecommendations.vue
      author:wpx
      time:20.08.19
      description:
   -->
   <div class="related-recommendations">
      <div class="title-and-open-app">
          <div class="title">
            相关推荐
          </div>
          <go-app :app-url="appUrl" class="go-app">
              <van-button type="primary">打开电子星球App看更多 <van-icon name="arrow" /></van-button>
          </go-app>
      </div>
      <div class="article-list">
          <div v-for="(item,index) in detailRelative" :key="index" class="article-item">
              <div class="title">{{item.title}}</div>
              <div class="img"><img :src="item.cover_image" v-if="item.cover_image !== ''"/></div>
              <div class="auth">{{item.nickname}}</div>
              <go-app :app-url="appUrl.split('=')[0]+'='+item.id" class="go-app">
                  <van-button type="primary">App查看</van-button>
              </go-app>
          </div>

      </div>
   </div>
</template>

<script>
import GoApp from '../../components/Common/GoApp'
export default{
  name: 'RelatedRecommendationsComponents',
  data () {
    return {
      appUrl: 'eestar://eestar/article_detail?article_id=' + this.$route.params.id
    }
  },
  props: {
    detailRelative: {
      type: Array
    }
  },
  components: {
    GoApp
  }
}
</script>

<style lang="less" scoped>
  .related-recommendations{
    padding: 0 16px;
    .title-and-open-app{
      height: 59px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .title{
        width:72px;
        height:24px;
        font-size:17px;
        font-weight:600;
        color:rgba(51,51,51,1);
        line-height:24px;
        margin-top: 20px;
      }
      .van-button--primary{
        widows: 156px;
        height:18px;
        font-size:13px;
        color: #753AB7;
        line-height:18px;
        font-weight:400;
        background: none;
        border:none;
      }
      .van-button--normal{
        padding: 0;
      }
      /deep/.van-icon-arrow{
        font-size: 12px;
        transform: scale(0.9);
        transform: translate(0px, 1px);
      }
    }
    .article-list{
      .article-item{
        height: 79px;
        margin-bottom: 15px;
        .title{
          width:190px;
          height:48px;
          font-size:17px;
          font-weight:400;
          color:rgba(51,51,51,1);
          line-height:24px;
          overflow : hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          float: left;
        }
        .auth{
          // width:32px;
          height:18px;
          font-size:13px;
          font-weight:400;
          color:rgba(153,153,153,1);
          line-height:18px;
          float: left;
          margin-top: 10px;
        }
        .van-button--primary{
          widows: 26px;
          height:18px;
          font-size:13px;
          color: #753AB7;
          line-height:18px;
          font-weight:400;
          background: none;
          border:none;
          float: left;
          margin: 10px 0 0 10px;
        }
        .van-button--normal{
          padding: 0;
        }
        .img{
          width: 140px;
          height: 79px;
          float: right;
          img{
            width: 100%;
            height: 100%;
            display: block;
            vertical-align: middle;
            border: none;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Article/RelatedRecommendations.vue